import { render } from "./flash.vue?vue&type=template&id=0dec384a"
import script from "./flash.js?vue&type=script&lang=js&external"
export * from "./flash.js?vue&type=script&lang=js&external"

import "./flash.vue?vue&type=style&index=0&id=0dec384a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__